
export default {
  i18nComponentKey: 'ReviewsNew.components.RewardSummary',
  name: 'RewardSummary',
  props: {
    currentReward: { type: Number, required: true },
    maxReward: { type: Number, required: true },
    isRewardEligible: { type: Boolean, required: true },
    isStuck: { type: Boolean, required: true }
  },
  computed: {
    remainingReward() {
      return Math.max(0, this.maxReward - this.currentReward);
    }
  }
};
